import React from 'react';
import styles from 'styles/components/MaintenanceNotices.module.sass';
import { formatLocalTime } from './format';
import { isBlockingNotice } from './logic';
import { MaintenanceNotice } from './types';

interface NoticeListProps {
  notices: readonly MaintenanceNotice[];
  /** Smaller, boxed variant for placing next to a control. */
  compact?: boolean;
}

const noticeKey = (n: MaintenanceNotice) =>
  `${n.state}|${n.mode}|${n.area ?? ''}|${n.title}|${n.startsAt}`;

/**
 * Renders notices that do not replace a page: active banners, upcoming
 * (information only) notices and, in compact placements, a blocking one.
 */
const NoticeList: React.FC<NoticeListProps> = ({ notices, compact = false }) => {
  if (notices.length === 0) return null;
  const now = new Date();

  return (
    <div className={compact ? styles['notice-list-compact'] : styles['notice-list']}>
      {notices.map((notice) => {
        const blocking = isBlockingNotice(notice);
        const upcoming = notice.state === 'upcoming';
        const kind = blocking ? 'blocking' : upcoming ? 'upcoming' : 'banner';
        const starts = formatLocalTime(notice.startsAt, now);

        return (
          <div
            key={noticeKey(notice)}
            className={`${styles['notice']} ${styles[kind]}`}
            role={blocking ? 'alert' : 'status'}
          >
            <p className={styles['notice-title']}>
              {upcoming
                ? `Scheduled maintenance: ${notice.title}${starts ? `, starts ${starts}` : ''}`
                : notice.title}
            </p>
            {notice.message && <p className={styles['notice-message']}>{notice.message}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default NoticeList;
